export default __webpack_public_path__ + "static/media/one-direction.e23a6974.jpg";